import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import SelectTenant from '../../components/Select/SelectTenant';

class GroupsManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.group.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });
      await this.props.group.getGroupCMSList(offset, limit, search, sort, order, tenantIds);
      this.props.group.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.group.resetData();
      await this.props.group.setData('tenantIds', tenantIds);
      // await this.props.group.getGroupCMSList();
    }
  }

  createGroup() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('groups/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_group')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.group.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.group.setData('offset', 0, false);
    this.props.group.setData('search', value);
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    await this.props.group.setData('tenantIds', tenantIds);
    localStorage.removeItem('select_tenant');
    localStorage.removeItem('select_module');
    localStorage.removeItem('select_group');
    if (tenantIds.length === 1) {
      localStorage.setItem('select_tenant', tenantIds[0]);
    }
  };

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('remove_this_group')}`,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('remove')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.group.deleteGroup(id);

          // delete group from groupPermission as well
          await this.props.user.updateGroupPermission([id]);

          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('remove_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.group.toJS();
                await this.props.group.getGroupCMSList(offset, limit, search, sort, order, tenantIds);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        }
      }
      // else if (result.dismiss === Swal.DismissReason.cancel) {
      //   Swal.fire({html: "<h4>Cancelled <br/>This group has not been remove. :)", type: "error"});
      // }
    });
  }

  unassign(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('unassign_module')}`,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('unassign')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          // get all subgroups before they are unassinged
          const subgroups = await this.props.subGroup.getSubGroupByGroupID(id);

          const result = await this.props.subGroup.unAssignModules(id);

          // delete subgroup from subgroupPermission as well
          const subgroupIds = [];
          (subgroups || []).map((subgroup) => {
            subgroupIds.push(subgroup.id);
            return true;
          });
          await this.props.user.updateSubgroupPermission(subgroupIds);

          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('unassign_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.group.toJS();
                await this.props.group.getGroupCMSList(offset, limit, search, sort, order, tenantIds);
              } else {
                Swal.fire({ html: `<h4>${t('failed_to_unassign')}`, type: 'error' });
              }
            });
          }
        } catch (e) {
          console.log('error', e);
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_unassign')}`, type: 'error' });
          }
        }
      }
    });
  }

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.group.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.group.toJS();
    this.props.group.setData('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    let { groupscms, loading, limit, search, sort, order } = this.props.group.toJS();

    const page = groupscms.data ? groupscms.pagination.page - 1 : 0;
    const count = groupscms.data ? groupscms.pagination.count : 0;

    const ARRAYSIZE = 6;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[1]}</div>;
          },
        },
      },
      {
        name: 'location.name',
        label: `${t('location')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'location.name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'totalModule',
        label: `${t('no_of_modules')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[3]}</div>;
          },
        },
      },
      {
        name: 'tenant.name',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[4]}</div>;
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                <Link to={`/app/groups/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/assign`}>
                  <Button variant='outlined' color='primary' className={classes.button}>
                    {t('assign_module')}
                  </Button>
                </Link>
                <Link to={`/app/groups/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`} title={t('view')}>
                  <IconButton>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link to={`/app/groups/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`} title={t('edit')}>
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  disabled={this.validateTableRow(row, ARRAYSIZE) && row[3] ? false : true}
                  id={`unassign-${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}`}
                  title={t('unassign')}
                  onClick={() => this.unassign(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.LinkOff color={this.validateTableRow(row, ARRAYSIZE) && row[3] ? 'primary' : 'disabled'} />
                </IconButton>
                <IconButton
                  disabled={this.validateTableRow(row, ARRAYSIZE) && row[3] ? true : false}
                  title={t('delete')}
                  id={`delete-${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}`}
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete color={this.validateTableRow(row, ARRAYSIZE) && row[3] ? 'disabled' : 'primary'} />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_groups')} button={this.createGroup()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={groupscms.data || []}
              columns={columns}
              options={{
                count: groupscms.data ? groupscms.pagination.count : 0,
                page: groupscms.data ? groupscms.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.group.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.group.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.group.setData('offset', 0, false);
                      this.props.group.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.group.setData('offset', 0, false);
                      this.props.group.setData('sort', sortList[4], false);
                      this.props.group.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
    marginTop: 11,
  },
  actionBox: {
    minWidth: '340px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('group', 'locations', 'subGroup', 'user')(observer(GroupsManager));
export const translation = withTranslation()(page);

export default withStyles(styles, { withTheme: true })(translation);
